<template>
  <div>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'

useHead({ title: 'Invoices' })
const $route = useRoute()
</script>
